<template>
    <v-container
        fluid
        class="px-4"
        v-if="customerGroup"
        :style="{
            paddingBottom: '80px'
        }">
        <v-row>
            <v-col cols="12">
                <div
                    class="subtitle-2 pb-2 font-weight-bold"
                    v-html="$t('customerGroupList.details.name')"/>
                <v-combobox
                    outlined
                    hide-details
                    height="40px"
                    append-icon="expand_more"
                    v-model="customerGroup.name"
                    :items="customerGroupList"
                    :placeholder="$t('placeholder.customer')"/>
            </v-col>
            <v-col cols="12" class="pb-0">
                <v-card-actions class="pa-0">
                    <div
                        :style="{
                            width: '250px'
                        }"
                        class="subtitle-1 pb-2 font-weight-bold"
                        v-html="$t('customerGroupList.details.addressInfo')"/>
                    <hr class="full-width ma-4">
                </v-card-actions>
            </v-col>
            <v-col cols="12">
                <div
                    class="subtitle-2 pb-2 font-weight-bold"
                    v-html="$t('customerGroupList.details.company')"/>
                <v-textarea
                    outlined
                    hide-details
                    v-model="customerGroup.addressInfo.info"
                    :placeholder="$t('placeholder.companyAddress')"/>
            </v-col>
            <v-col cols="12">
                <div
                    class="subtitle-2 pb-2 font-weight-bold"
                    v-html="`${$t('customerGroupList.details.province')} ${$t('required')}`"/>
                <v-combobox
                    outlined
                    hide-details
                    append-icon="expand_more"
                    height="40px"
                    v-model="customerGroup.addressInfo.province"
                    :items="provinceList"
                    :placeholder="$t('placeholder.province')"/>
            </v-col>
            <v-col cols="12">
                <div
                    class="subtitle-2 pb-2 font-weight-bold"
                    v-html="$t('customerGroupList.details.phone')"/>
                <v-text-field
                    outlined
                    hide-details
                    height="40px"
                    v-model="customerGroup.addressInfo.phone"
                    :placeholder="$t('placeholder.phone')"/>
            </v-col>
            <v-col cols="12">
                <div
                    class="subtitle-2 pb-2 font-weight-bold"
                    v-html="$t('customerGroupList.details.tax')"/>
                <v-text-field
                    outlined
                    hide-details
                    height="40px"
                    v-model="customerGroup.addressInfo.taxNumber"
                    :placeholder="$t('placeholder.tax')"/>
            </v-col>
            <v-col cols="12" class="pb-0">
                <v-card-actions class="pa-0">
                    <div
                        class="subtitle-1 pb-2 font-weight-bold"
                        v-html="$t('customerGroupList.details.delivery')"/>
                    <hr
                        class="ma-4"
                        :style="{ width: '32%' }">
                    <v-checkbox
                        hide-details
                        v-model="customerGroup.isUseCompanyAddress"
                        class="mt-0"
                        :label="$t('customerGroupList.details.useCompany')"/>
                </v-card-actions>
            </v-col>
            <v-col cols="12">
                <div
                    class="subtitle-2 pb-2 font-weight-bold"
                    v-html="$t('customerGroupList.details.address')"/>
                <v-textarea
                    outlined
                    hide-details
                    v-model="customerGroup.deliveryAddress.info"
                    :disabled="customerGroup.isUseCompanyAddress"
                    :placeholder="$t('placeholder.address')"/>
            </v-col>
            <v-col cols="12">
                <div
                    class="subtitle-2 pb-2 font-weight-bold"
                    v-html="$t('customerGroupList.details.province')"/>
                <v-text-field
                    outlined
                    hide-details
                    height="40px"
                    v-model="customerGroup.deliveryAddress.province"
                    :disabled="customerGroup.isUseCompanyAddress"
                    :placeholder="$t('placeholder.province')"/>
            </v-col>
            <v-col cols="12" class="pb-0">
                <v-card-actions class="pa-0">
                    <div
                        :style="{
                            width: '250px'
                        }"
                        class="subtitle-1 font-weight-bold"
                        v-html="$t('customerGroupList.details.contact')"/>
                    <hr class="full-width ma-4">
                </v-card-actions>
            </v-col>

            <v-col cols="12">
                <div
                    class="subtitle-2 pb-2 font-weight-bold"
                    v-html="`${$t('customerGroupList.details.contactName')} ${$t('required')}`"/>
                <v-text-field
                    outlined
                    hide-details
                    height="40px"
                    v-model="customerGroup.contact.name"
                    :placeholder="$t('placeholder.contactName')"/>
            </v-col>
            <v-col cols="12">
                <div
                    class="subtitle-2 pb-2 font-weight-bold"
                    v-html="`${$t('customerGroupList.details.contactNumber')} ${$t('required')}`"/>
                <v-text-field
                    outlined
                    hide-details
                    height="40px"
                    v-model="customerGroup.contact.phone"
                    :placeholder="$t('placeholder.contactNumber')"/>
            </v-col>
        </v-row>
    </v-container>
    <div v-else />
</template>

<script>
const province = require('../assets/province.json')

export default {
    name: 'CustomerGroupDetailsView',

    props: {
        customerGroup: {
            type: Object,
            default: null
        },

        createMode: {
            type: Boolean,
            default: false
        }
    },

    data () {
        const provinceList = province.map(p => p.PROVINCE_NAME)
        const customerGroupList = [
            'Pi R Sqaure',
            'Pi R',
            'Proud Group',
            'Andamanda'
        ]
        return {
            provinceList,
            customerGroupList
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
